import { Fragment, useState } from 'react';

import { css } from '@compiled/react';

import { TypographyStyles } from '@/libraries/wpl/foundations/src/typography-styles';

import { AfterOnboardingStep } from './after-onboarding-step';
import { CornerLoomLogo } from './components/corner-loom-logo';
import { StepManager } from './utilities/step-manager';

const containerStyle = css({
	display: 'flex',
	flexFlow: 'column',
	alignItems: 'center',
	textAlign: 'center',
	paddingInline: '2rem',
});

export const LoomOnboardingView = () => {
	const [onboardingComplete, setOnboardingComplete] = useState(false);

	const handleOnboardingComplete = () => {
		setOnboardingComplete(true);
	};

	return (
		<TypographyStyles>
			<Fragment>
				<CornerLoomLogo />
				<div css={containerStyle} data-testid="loom-onboarding-view">
					{onboardingComplete ? (
						<AfterOnboardingStep />
					) : (
						<StepManager handleContinue={handleOnboardingComplete} />
					)}
				</div>
			</Fragment>
		</TypographyStyles>
	);
};

export default LoomOnboardingView;
